import React from "react";
import Typography from "@material-ui/core/Typography";
const Investor = ({}) => {
  return (
    <React.Fragment>
      <Typography paragraph variant="h4">
        Investor
      </Typography>
      <Typography paragraph variant="h5">
        Focus on customers and partners, and grow with them by the bootstrapping
        way.
      </Typography>
      <Typography paragraph variant="body1">
        Currently, Invifo as the core company is growing in the founders' hands
        by bootstrapping without investors. The founders want more focus on how
        the company can give benefits to the customers and partners as the core
        of business fundamentals.
      </Typography>
    </React.Fragment>
  );
};

export default Investor;
